<template>
  <div class="default-modal">
    <el-dialog
      width="70%"
      top="15vh"
      v-model="exportReportsDialogVisisble"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part"><h3>CASE REPORT</h3></div>

        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div class="selected-string" v-if="selected_case_type">
        <h3>
          Selected caseType :
          <span class="value">{{ getCaseTypeMap(selected_case_type) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_dob">
        <h3>
          Selected DOB :
          <span class="value">{{ selectedDob(selected_dob) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          search_case_status &&
          Array.isArray(this.search_case_status) &&
          this.search_case_status.length
        "
      >
        <h3>
          Selected Status :
          <span
            class="value"
            v-for="(caseStatus, index) of getStatusMap(search_case_status)"
            :key="index"
            >{{ caseStatus }}
            <span v-if="index + 1 < search_case_status.length">,</span>
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_hospital">
        <h3>
          Selected Ordering Facility :
          <span class="value"
            >{{ getSelectedHospital(selected_hospital) }}
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_physician">
        <h3>
          Selected Physician :
          <span class="value"
            >{{ getSelectedPhysician(selected_physician).name }}
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_string">
        <h3>
          Selected String :
          <span class="value">{{ selected_string }} </span>
        </h3>
      </div>
      <div class="dialog-body">
        <div class="export-popup-body" v-loading="loading">
          <div class="select-fields">
            <el-checkbox-group v-model="activeFieldList">
              <ul class="select-fields-list">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in exportCasesExcelFields"
                  :key="index"
                >
                  <el-checkbox :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button
          class="cancel-button"
          @click="handleClear"
          :disabled="!this.activeFieldList.length"
          >CLEAR ALL</el-button
        >
        <el-button class="cancel-button" @click="handleCheckAllChange"
          >SELECT ALL</el-button
        >
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button class="blue-save-button" @click="downloadCases">
          DOWNLOAD
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import moment from "moment";
export default {
  mixins: [
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],
  props: [
    "selected_dob",
    "selected_case_type",
    "selected_hospital",
    "selected_physician",
    "selected_string",
    "search_case_status",
  ],
  computed: {
    mappedSelectedOptions() {
      return this.activeFieldList.map((option) => {
        return this.exportExtraCasesExcelFields.find(
          (opt) => opt.value === option
        );
      });
    },
    ...mapGetters("cases", ["getDownloadCaseDataStatus"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),

    getCaseTypeMap() {
      return (status) => this.caseTypeMap[status];
    },
    getStatusMap() {
      return (status) => {
        return (status || []).map((e) => this.statusMap[e]);
      };
    },
    selectedDob() {
      return (selected_dob) => moment(selected_dob).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      exportReportsDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      date_type: "collection_date",
      status: "",
      statusMap: caseConstants.STATUS_TYPE_MAP,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      billing_status: "SENT",
    };
  },
  created() {
    this.activeFieldList = [
      ...this.defaultExportCasesExcelFields.map((opt) => opt.value),
    ];
  },
  async mounted() {
    this.loading = true;
    this.status = this.search_case_status;
    this.loading = false;
  },
  methods: {
    handleClear() {
      this.activeFieldList = [];
    },
    getSelectedHospital(hospitalId) {
      return this.getAllHospitals.data
        .filter((hospital) => hospitalId.indexOf(hospital._id) != -1)
        .flatMap((hospital) => hospital.name)
        .join(", ");
    },
    getSelectedPhysician(physicianId) {
      return this.getAllPhysicians.data.find(
        (physician) => physician._id == physicianId
      );
    },
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportCasesExcelFields &&
        this.activeFieldList.length &&
        this.exportCasesExcelFields.length &&
        this.activeFieldList.length == this.exportCasesExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async downloadCases() {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
          billing_status: this.billing_status,
        };

        params.date_type = this.date_type;

        if (
          this.search_case_status &&
          Array.isArray(this.search_case_status) &&
          this.search_case_status.length > 1
        ) {
          params.case_status = this.search_case_status;
        } else if (this.search_case_status && this.search_case_status.length) {
          params.status = this.search_case_status.toString();
        } else if (Object.keys(params).indexOf("status") != -1) {
          delete params.status;
        }
        if (this.selected_string != "") {
          params.search_string = this.selected_string;
        }
        if (this.selected_case_type && this.selected_case_type.length) {
          params.case_types = [this.selected_case_type];
        }
        if (this.selected_hospital && this.selected_hospital.length) {
          params.hospital = this.selected_hospital;
        }
        if (this.selected_physician != "") {
          params.ordering_physician = this.selected_physician;
        }
        if (this.selected_dob != "") {
          const date_of_birth = moment(this.selected_dob).format("YYYY-MM-DD");

          params.date_of_birth = date_of_birth;
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    close() {
      this.$emit("close");
    },
    handleCheckAllChange() {
      this.exportExtraCasesExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
  },
};
</script>
<style lang="scss" scoped>
.select-fields {
  ul {
    -webkit-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 20px;
    column-gap: 20px;
    li {
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
}
.all-cases-view {
  .inner-navbar {
    .flex-wrap {
      flex-wrap: wrap;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      li {
        &:not(:last-child) {
          margin-right: 1em;
        }
        .add-btn {
          padding: 9px 15px;
          background: #6f52ed;
          border-radius: 3px;
          color: #fff;
          border: none;
          font-weight: 500;
          text-transform: uppercase;
          img {
            margin-right: 10px;
            margin-bottom: -3px;
          }
        }
      }
    }
  }
  .content {
    margin-top: 20px;
    background: #fff;
  }

  .view-test-reports {
    .inner-navbar {
      display: none !important;
    }
  }
  .export-cases {
    .form-control {
      margin-bottom: 30px;
    }
    .radio-block {
      label {
        margin-bottom: 8px;
        display: block;
      }
      .el-radio-group {
        display: flex;
      }
    }
  }
  .accession {
    color: #ff004c;
    letter-spacing: 0.09em;
  }
  .patient-name {
    color: #1349a5;
  }
  .user-icon {
    width: 20px;
    vertical-align: middle;
    padding-right: 4px;
  }
  .second-row-button ul {
    margin-top: 20px;
    justify-content: flex-end;
  }

  @media (min-width: 0) and (max-width: 767px) {
    .form-group {
      width: 180px;
      float: right;
    }
  }
}
</style>
